export const elementIds = {
  btnApprovePaymentFile: 'btnApprovePaymentFile',
  btnConfirmApprovePaymentFile: 'btnConfirmApprovePaymentFile',
  btnCancelApprovePaymentFile: 'btnCancelApprovePaymentFile',
  btnRejectPaymentFile: 'btnRejectPaymentFile',
  btnConfirmRejectPaymentFile: 'btnConfirmRejectPaymentFile',
  btnCancelRejectPaymentFile: 'btnCancelRejectPaymentFile',
  btnDismissSuccessfulRejectMessage: 'btnDismissSuccessfulRejectMessage',
};
